import { NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * module to encapsule SVG icon imports
 *
 * svg source files in {@link #sourcePath} get imported and registered
 * when declared in {@link #sourceNames}
 * then these are automatically added to the icon registry
 * so that a named svg icon can be used just like normal material icons:
 *
 * **basic usage:**
 *
 * ```html
 *  <mat-icon [svgIcon]="name"></mat-icon>
 * ```
 *
 */
@NgModule({
    declarations: [],
    imports: [CommonModule]
})
export class SvgIconModule {
    /** path to svg sources */
    private sourcePath = 'assets/icons';

    /** list of svg filenames */
    private sourceNames = [
        'macos',
        'windows',
        'ms-entra-id',
        'avatar_placeholder',
        'scope-anchor',
        'scope-bubbly-rabbit',
        'scope-bumble-bee',
        'scope-celebrating-specialist',
        'scope-clever-nerd',
        'scope-clumsy-penguin',
        'scope-cool-specialist',
        'scope-crying-specialist',
        'scope-cuddly-cat',
        'scope-devoted-dog',
        'scope-happy-specialist',
        'scope-laughing-specialist',
        'scope-lovestruck-specialist',
        'scope-mad-monkey',
        'scope-majestic-unicorn',
        'scope-organized-ox',
        'scope-santa-scope',
        'scope-articulated-lorry',
        'scope-checkmark',
        'scope-container',
        'scope-customs',
        'scope-delivery-truck',
        'scope-flexed-biceps',
        'scope-generic',
        'scope-golf',
        'scope-heart',
        'scope-laptop',
        'scope-mobilephone-2',
        'scope-mobilephone',
        'scope-package',
        'scope-pile-of-poo',
        'scope-plane',
        'scope-pumpkin',
        'scope-pushpin',
        'scope-seedling',
        'scope-ship',
        'scope-skull',
        'scope-soccer-ball',
        'scope-sombrero',
        'scope-sneaky-snake',
        'scope-winking-specialist'
    ];

    #iconRegistry = inject(MatIconRegistry);
    sanitizer = inject(DomSanitizer);

    constructor() {
        this.sourceNames.forEach((name) => {
            this.#iconRegistry.addSvgIcon(
                `${name}`,
                this.sanitizer.bypassSecurityTrustResourceUrl(`${this.sourcePath}/${name}.svg`)
            );
        });

        // custom icon resolver to catch error of misspelled icons
        this.#iconRegistry.addSvgIconResolver(() =>
            this.sanitizer.bypassSecurityTrustResourceUrl(`${this.sourcePath}/avatar_placeholder.svg`)
        );
    }
}
